<template>
  <div>
    <head-nav-bar title :fixed="true" />
    <div class="mt-header-nav">
      <div class="article-info">
        <div class="title">{{ info[titleField] }}</div>
        <div class="sub">
          <span class="author">{{ info[authorField] }}</span>
          <span class="date">{{ info[dateField] }}</span>
        </div>
        <div class="content" v-html="info[contentField]"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    api: {
      type: String,
      default: "",
    },
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
    titleField: {
      type: String,
      default: "title",
    },
    descField: {
      type: String,
      default: "subTitle",
    },
    dateField: {
      type: String,
      default: "creationTime",
    },
    authorField: {
      type: String,
      default: "creatorUserName",
    },
    contentField: {
      type: String,
      default: "content",
    },
  },
  data() {
    return {
      info: {},
    };
  },
  created() {
    if (this.api) {
      this.getInfo();
    } else if (this.data && this.data.id) {
      this.info = this.data;
    }
  },
  methods: {
    getInfo() {
      this.$post(this.api, this.params).then(res => {
        this.info = res.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.article-info {
  padding: 0 0.3rem 0.3rem 0.3rem;
  .title {
    font-size: 0.5rem;
    line-height: 1.6;
  }
  .sub {
    margin: 0.3rem 0;
    font-size: 0.3rem;
    .author {
      margin-right: 0.5rem;
    }
  }
  .content {
    font-size: 0.35rem;
  }
}
</style>
